/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { WriteWithAIResponseSuggestedDoc } from './writeWithAIResponseSuggestedDoc';

export interface WriteWithAIResponse {
  suggested_doc: WriteWithAIResponseSuggestedDoc;
  tokens_used?: number;
}
